// RechercheInformeContext.jsx

import React, { createContext, useState } from 'react';

const RechercheInformeContext = createContext();

export const RechercheInformeProvider = ({ children }) => {
  // Filtres
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedEventos, setSelectedEventos] = useState([]);
  const [selectedPlayerType, setSelectedPlayerType] = useState('all');

  // Gestion de l'état d'ouverture des rows
  const [openRows, setOpenRows] = useState({});

  // Gère l'ouverture/fermeture d'une ligne (informe)
  const toggleRow = (rowId) => {
    setOpenRows((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  return (
    <RechercheInformeContext.Provider
      value={{
        // Filtres
        selectedPlayer,
        setSelectedPlayer,
        selectedUser,
        setSelectedUser,
        selectedEventos,
        setSelectedEventos,
        selectedPlayerType,
        setSelectedPlayerType,

        // Rows ouvertes
        openRows,
        setOpenRows,
        toggleRow,
      }}
    >
      {children}
    </RechercheInformeContext.Provider>
  );
};

export default RechercheInformeContext;
